import styled from 'styled-components'

export const Subtitle = styled.div`
  font-weight: 600;
  opacity: 0.5;
  margin-bottom: 24px;
`
